module.exports = __webpack_public_path__ + "static/img/30013 (1).2925231.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30013 (1).webp
// module id = W7SX
// module chunks = 14